<template>
  <div class="home">
    <!-- 使用公共头部组件 -->
    <Header />
    
    <!-- 主要内容区域 -->
    <main class="main-content">
      <!-- 英雄区域 -->
      <section class="hero-section">
        <div class="hero-container">
          <div class="hero-content">
            <div class="hero-badge">
              <span>专业 · 权威 · 可信</span>
            </div>
            <h1 class="hero-title">
              引领检验检测
              <span class="highlight">新标准</span>
            </h1>
            <p class="hero-subtitle">
              以科技创新为驱动，为各行业提供精准、高效的检验检测服务，
              助力企业质量提升与可持续发展
            </p>
            <!-- 上传报告相关按钮已隐藏 -->
            <!-- <div class="hero-buttons">
              <el-button type="primary" size="large" @click="goToUpload" class="primary-btn">
                <el-icon><Upload /></el-icon>
                立即上传报告
              </el-button>
              <el-button size="large" @click="goToReportList" class="secondary-btn">
                <el-icon><Document /></el-icon>
                查看检测报告
              </el-button>
            </div> -->
            <div class="hero-stats">
              <div class="stat-item">
                <div class="stat-number">10000+</div>
                <div class="stat-label">检测样本</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">500+</div>
                <div class="stat-label">合作企业</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">99.9%</div>
                <div class="stat-label">准确率</div>
              </div>
            </div>
          </div>
          <div class="hero-visual">
            <div class="hero-image-container">
              <div class="floating-card card-1">
                <el-icon><Trophy /></el-icon>
                <span>权威认证</span>
              </div>
              <div class="floating-card card-2">
                <el-icon><Timer /></el-icon>
                <span>快速检测</span>
              </div>
              <div class="floating-card card-3">
                <el-icon><Shield /></el-icon>
                <span>质量保证</span>
              </div>
              <div class="hero-graphic">
                <div class="graphic-circle circle-1"></div>
                <div class="graphic-circle circle-2"></div>
                <div class="graphic-circle circle-3"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 服务特色 -->
      <section class="features-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">为什么选择我们</h2>
            <p class="section-subtitle">专业的技术团队，先进的检测设备，严格的质量控制</p>
          </div>
          <div class="features-grid">
            <div class="feature-card" v-for="(feature, index) in features" :key="index">
              <div class="feature-icon" :class="`icon-${index + 1}`">
                <component :is="feature.icon" />
              </div>
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
              <div class="feature-number">{{ String(index + 1).padStart(2, '0') }}</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 检测服务 -->
      <section class="services-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">专业检测服务</h2>
            <p class="section-subtitle">覆盖多个行业领域，提供全方位检测解决方案</p>
          </div>
          <div class="services-grid">
            <div class="service-card" v-for="(service, index) in services" :key="index">
              <div class="service-icon">
                <component :is="service.icon" />
              </div>
              <div class="service-content">
                <h3>{{ service.title }}</h3>
                <p>{{ service.description }}</p>
                <ul class="service-features">
                  <li v-for="item in service.features" :key="item">{{ item }}</li>
                </ul>
                <el-button type="primary" text @click="goToServices">
                  了解详情
                  <el-icon><ArrowRight /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 数据展示 -->
      <section class="stats-section">
        <div class="container">
          <div class="stats-grid">
            <div class="stat-card" v-for="(stat, index) in stats" :key="index">
              <div class="stat-icon">
                <component :is="stat.icon" />
              </div>
              <div class="stat-content">
                <div class="stat-number">{{ stat.number }}</div>
                <div class="stat-label">{{ stat.label }}</div>
                <div class="stat-desc">{{ stat.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 新闻资讯 -->
      <section class="news-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">最新资讯</h2>
            <p class="section-subtitle">了解行业动态，掌握检测技术前沿</p>
          </div>
          <div class="news-grid">
            <div class="news-card" v-for="(news, index) in newsItems" :key="index">
              <div class="news-date">
                <span class="date-day">{{ news.day }}</span>
                <span class="date-month">{{ news.month }}</span>
              </div>
              <div class="news-content">
                <div class="news-category">{{ news.category }}</div>
                <h3>{{ news.title }}</h3>
                <p>{{ news.summary }}</p>
                <el-button type="primary" text @click="goToNewsDetail(news.id)">
                  阅读更多
                  <el-icon><ArrowRight /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA区域 -->
      <section class="cta-section">
        <div class="container">
          <div class="cta-content">
            <h2>开始您的检测之旅</h2>
            <p>专业团队为您提供一站式检测服务解决方案</p>
            <div class="cta-buttons">
              <!-- 上传按钮已隐藏 -->
              <!-- <el-button type="primary" size="large" @click="goToUpload">
                <el-icon><Upload /></el-icon>
                立即上传
              </el-button> -->
              <el-button size="large" @click="contactUs" class="contact-btn">
                <el-icon><Phone /></el-icon>
                联系我们
              </el-button>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 使用公共底部组件 -->
    <Footer />
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { 
  // Upload,  // 已移除，不再使用
  // Document,  // 已移除，不再使用
  Trophy, 
  Timer, 
  Shield, 
  Service,
  ArrowRight,
  Phone,
  DataAnalysis,
  Monitor,
  Setting,
  TrendCharts,
  Files,
  User,
  Star
} from '@element-plus/icons-vue'

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    // Upload, // 已移除
    // Document, // 已移除
    Trophy,
    Timer,
    Shield,
    Service,
    ArrowRight,
    Phone,
    DataAnalysis,
    Monitor,
    Setting,
    TrendCharts,
    Files,
    User,
    Star
  },
  setup() {
    const router = useRouter()

    const features = ref([
      {
        icon: 'Trophy',
        title: '权威认证',
        description: '拥有国家认可的检测资质和CNAS认证，确保检测结果的权威性和国际互认'
      },
      {
        icon: 'Timer',
        title: '快速响应',
        description: '7×24小时服务响应，标准检测周期3-5个工作日，紧急检测24小时出结果'
      },
      {
        icon: 'Shield',
        title: '质量保证',
        description: '严格的质量管理体系，全程质量控制，确保每份报告的准确性和可靠性'
      },
      {
        icon: 'Service',
        title: '专业服务',
        description: '资深技术专家团队，提供专业技术咨询和个性化检测解决方案'
      }
    ])

    const services = ref([
      {
        icon: 'DataAnalysis',
        title: '食品检测',
        description: '全面的食品安全检测服务',
        features: ['营养成分分析', '农药残留检测', '重金属检测', '微生物检测']
      },
      {
        icon: 'Monitor',
        title: '环境检测',
        description: '专业的环境监测服务',
        features: ['水质检测', '空气质量检测', '土壤检测', '噪声检测']
      },
      {
        icon: 'Setting',
        title: '材料检测',
        description: '各类材料性能检测',
        features: ['金属材料检测', '建筑材料检测', '化工材料检测', '纺织品检测']
      }
    ])

    const stats = ref([
      {
        icon: 'TrendCharts',
        number: '15+',
        label: '年专业经验',
        description: '深耕检测行业'
      },
      {
        icon: 'Files',
        number: '50000+',
        label: '检测报告',
        description: '累计出具报告'
      },
      {
        icon: 'User',
        number: '1000+',
        label: '服务客户',
        description: '遍布全国各地'
      },
      {
        icon: 'Star',
        number: '99.8%',
        label: '客户满意度',
        description: '持续优质服务'
      }
    ])

    // 从共享数据源获取最新新闻
    const { getLatestNews } = require('@/data/newsData')
    const newsItems = ref(getLatestNews(3))

    // 上传报告相关方法已移除
    // const goToUpload = () => {
    //   router.push('/upload')
    // }

    // const goToReportList = () => {
    //   router.push('/ReportList')
    // }

    const goToServices = () => {
      router.push('/services')
    }

    const goToNews = () => {
      router.push('/news')
    }

    const goToNewsDetail = (newsId) => {
      router.push(`/news/${newsId}`)
    }

    const contactUs = () => {
      // 可以打开联系我们的弹窗或跳转到联系页面
      console.log('联系我们')
    }

    return {
      features,
      services,
      stats,
      newsItems,
      // goToUpload, // 已移除
      // goToReportList, // 已移除
      goToServices,
      goToNews,
      goToNewsDetail,
      contactUs
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  margin-top: 80px; /* 为固定头部留出空间 */
}

/* 英雄区域 */
.hero-section {
  position: relative;
  background-image: url('@/assets/img/banner1.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  padding: 120px 0;
  overflow: hidden;

  @media (max-width: 768px) {
    height: calc(100vh - 60px);
    padding: 0;
    background-image: url('@/assets/img/Mbanner1.webp');
    background-size: 100% auto;
    background-position: top center;
    background-attachment: scroll;
    display: flex;
    align-items: center;
    overflow: hidden;

    .hero-container {
      width: 100%;
      padding: 0 20px;
      margin: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .hero-content {
      text-align: center;
      margin-bottom: 20px;
    }

    .hero-badge {
      margin-bottom: 15px;
      span {
        font-size: 14px;
        padding: 6px 12px;
      }
    }

    .hero-title {
      font-size: 24px;
      line-height: 1.3;
      margin-bottom: 10px;
    }

    .hero-subtitle {
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 20px;
    }

    .hero-stats {
      display: flex;
      justify-content: center;
      gap: 20px;
      margin-top: 20px;
    }

    .stat-item {
      .stat-number {
        font-size: 24px;
        font-weight: 700;
        background: linear-gradient(135deg, #003A8C, #1890ff);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
        /* letter-spacing: 0.5px;  */
      }
      .stat-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.9);
        margin-top: 4px;
        font-weight: 500;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
      }
    }

    .hero-visual {
      margin-top: 20px;
      transform: scale(0.8);
      position: relative;
      width: 100%;
    }

    .floating-card {
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(8px);
      border-radius: 12px;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
      padding: 10px 15px;
      display: flex;
      align-items: center;
      gap: 8px;
      position: absolute;
      
      .el-icon {
        font-size: 18px;
        color: #1890ff;
      }
      
      span {
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }

      &.card-1 {
        top: 10%;
        left: 15%;
        animation: float 3s ease-in-out infinite;
      }

      &.card-2 {
        top: 30%;
        right: 15%;
        animation: float 3s ease-in-out infinite 1s;
      }

      &.card-3 {
        bottom: 15%;
        left: 25%;
        animation: float 3s ease-in-out infinite 2s;
      }
    }
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><defs><pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse"><path d="M 50 0 L 0 0 0 50" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="1"/></pattern></defs><rect width="100%" height="100%" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.hero-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;
}

/* 移动端背景适配：避免 fixed 抖动，优化裁剪与空间 */
@media (max-width: 768px) {
  .hero-section {
    background-position: center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 100vh;
    padding: 100px 0 60px;
  }
  .hero-container {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

.hero-content {
  color: white;
}

.hero-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 30px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 25px;
}

.hero-title .highlight {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.2rem;
  line-height: 1.6;
  opacity: 0.9;
  margin-bottom: 40px;
  max-width: 500px;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  margin-bottom: 60px;
}

.primary-btn {
  height: 50px;
  padding: 0 30px;
  border-radius: 25px;
  font-weight: 600;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border: none;
  box-shadow: 0 8px 25px rgba(79, 172, 254, 0.4);
  transition: all 0.3s ease;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(79, 172, 254, 0.6);
}

.secondary-btn {
  height: 50px;
  padding: 0 30px;
  border-radius: 25px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  transition: all 0.3s ease;
}

.secondary-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

.hero-stats {
  display: flex;
  gap: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #4facfe;
  /* margin-bottom: 5px; */
}

.stat-label {
  font-size: 14px;
  /* opacity: 0.8; */
}

/* 英雄视觉区域 */
.hero-visual {
  position: relative;
  height: 500px;
}

.hero-image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.floating-card {
  position: absolute;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 20px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  color: #1e3c72;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: float 6s ease-in-out infinite;
}

.card-1 {
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.card-2 {
  top: 50%;
  right: 10%;
  animation-delay: 2s;
}

.card-3 {
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

.hero-graphic {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.graphic-circle {
  position: absolute;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.circle-1 {
  width: 200px;
  height: 200px;
  animation: rotate 20s linear infinite;
}

.circle-2 {
  width: 300px;
  height: 300px;
  top: -50px;
  left: -50px;
  animation: rotate 30s linear infinite reverse;
}

.circle-3 {
  width: 400px;
  height: 400px;
  top: -100px;
  left: -100px;
  animation: rotate 40s linear infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 通用容器和标题 */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e3c72;
  margin-bottom: 20px;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #4facfe, #00f2fe);
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* 特色功能区域 */
.features-section {
  padding: 120px 0;
  background: linear-gradient(135deg, #f8fbff 0%, #e8f4fd 100%);
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
}

.feature-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  position: relative;
  box-shadow: 0 10px 40px rgba(30, 60, 114, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4facfe, #00f2fe);
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(30, 60, 114, 0.15);
}

.feature-icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  font-size: 2rem;
  color: white;
  position: relative;
}

.feature-icon.icon-1 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.feature-icon.icon-2 {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.feature-icon.icon-3 {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.feature-icon.icon-4 {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.feature-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e3c72;
  margin-bottom: 15px;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.feature-number {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 3rem;
  font-weight: 800;
  color: rgba(30, 60, 114, 0.1);
}

/* 服务区域 */
.services-section {
  padding: 120px 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.service-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(30, 60, 114, 0.1);
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border-color: #4facfe;
}

.service-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  margin-bottom: 25px;
}

.service-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e3c72;
  margin-bottom: 15px;
}

.service-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.service-features {
  list-style: none;
  padding: 0;
  margin: 0 0 25px 0;
}

.service-features li {
  padding: 8px 0;
  color: #666;
  position: relative;
  padding-left: 20px;
}

.service-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #4facfe;
  font-weight: bold;
}

/* 数据统计区域 */
.stats-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
}

.stat-card {
  text-align: center;
  padding: 30px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 1.5rem;
  color: #4facfe;
}

.stat-card .stat-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #4facfe;
  margin-bottom: 10px;
}

.stat-card .stat-label {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.stat-desc {
  font-size: 14px;
  opacity: 0.8;
}

/* 新闻资讯区域 */
.news-section {
  padding: 120px 0;
  background: #f8fbff;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.news-card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  display: flex;
  gap: 25px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.news-date {
  text-align: center;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  padding: 15px;
  border-radius: 15px;
  min-width: 80px;
  height: fit-content;
}

.date-day {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
}

.date-month {
  display: block;
  font-size: 12px;
  opacity: 0.9;
}

.news-content {
  flex: 1;
}

.news-category {
  display: inline-block;
  background: rgba(79, 172, 254, 0.1);
  color: #4facfe;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 15px;
}

.news-content h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1e3c72;
  margin-bottom: 10px;
  line-height: 1.4;
}

.news-content p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
}

/* CTA区域 */
.cta-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  text-align: center;
}

.cta-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
}

.cta-content p {
  font-size: 1.2rem;
  opacity: 0.9;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.contact-btn {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  height: 50px;
  padding: 0 30px;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .hero-container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
  
  .hero-title {
    font-size: 3rem;
  }
  
  .hero-stats {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .main-content {
    margin-top: 70px;
  }
  
  .hero-section {
    padding: 80px 0 60px;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .hero-stats {
    flex-direction: column;
    gap: 20px;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .features-section,
  .services-section,
  .news-section {
    padding: 80px 0;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }
  
  .hero-section {
    padding: 60px 0 40px;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .features-grid,
  .services-grid,
  .news-grid {
    grid-template-columns: 1fr;
  }
  
  .news-card {
    flex-direction: column;
    text-align: center;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}
</style>